module.exports = __webpack_public_path__ + "static/media/nuomLogo.d4f9a940.png";